<woa-modal-page-layout [title]="'woa.heading.order-time.title'" woa-activatable (onActivate)="closeSelections()">
    @if (showStoreClosed()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.message.order-time.storeNameClosed'"
                             [translationParams]="{'storeName': orderingContextModel.currentStoreLocation()?.storeName}"></woa-content-message>
    }
    <div class="timing" woa-responsive [ngClass]="{'with-store-closed': showStoreClosed()}">
        <div class="timing-selection">
            @if (canOrderLater()) {
                <woa-selection-field class="timing-selection-field date"
                                     [disabled]="loadingTimes()"
                                     [label]="'woa.label.order-time.date'"
                                     [value]="dateFieldValue(orderDate()) | translate"
                                     [noMessage]="true" [toggleActive]="showDateSelect()"
                                     (onActivateField)="toggleDateSelection()"></woa-selection-field>
            }
            @if (canOrderLaterTime()) {
                <woa-selection-field class="timing-selection-field time"
                                     [disabled]="loadingTimes() || !timesAvailable()"
                                     [label]="'woa.label.order-time.time'" [value]="timeFieldValue() | translate"
                                     [noMessage]="true" [toggleActive]="showTimeSelect()"
                                     (onActivateField)="toggleTimeSelection()"></woa-selection-field>
            }
        </div>
        <div class="timing-select">
            @if (showDateSelect()) {
                <div class="timing-select-date-list drop-down">
                    <div class="timing-select-date-list-content">
                        @for (date of availableDates; track date; let i = $index) {
                            <div class="timing-select-date-list-content-date" woa-activatable
                                 (onActivate)="selectDate(date)">
                                <div class="timing-select-date-list-content-date-button" id="date-button-{{i}}">
                                    {{ dateFieldValue(date) | translate }}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
            @if (showTimeSelect() && configurationModel.app()?.showTimeGrid) {
                <div class="timing-select-time-grid drop-down">
                    <div class="timing-select-time-grid-content">
                        @for (group of availableTimes()?.specificTimeGroups; track group; let g = $index) {
                            <div class="timing-select-time-grid-content-group">
                                @for (time of group.specificTimes; track time; let t = $index) {
                                    <div class="timing-select-time-grid-content-group-time">
                                        <div class="timing-select-time-grid-content-group-time-cell"
                                             [ngClass]="{
                                                 'unavailable': !time.available,
                                                 'carryOver': time.carryOver
                                             }"
                                             id="time-grid-button-{{g}}-{{t}}"
                                             woa-activatable (onActivate)="selectTime(time)">
                                            {{ timeSlotLabel(time) | translate: {'time': formatTime(parseTime(time.time))} }}
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
            @if (showTimeSelect() && !configurationModel.app()?.showTimeGrid) {
                <div class="timing-select-time-list drop-down">
                    <div class="timing-select-time-list-content">
                        @for (group of availableTimes()?.specificTimeGroups; track group; let g = $index) {
                            @for (time of group.specificTimes; track time; let t = $index) {
                                @if (showTimeInList(time)) {
                                    <div class="timing-select-time-list-content-time">
                                        <div class="timing-select-time-list-content-time-button"
                                             [ngClass]="{
                                                 'unavailable': !time.available,
                                                 'carryOver': time.carryOver
                                             }"
                                             id="time-list-button-{{g}}-{{t}}"
                                             woa-activatable (onActivate)="selectTime(time)">
                                            {{ timeSlotLabel(time, true) | translate: {'time': formatTime(parseTime(time.time))} }}
                                        </div>
                                    </div>
                                }
                            }
                        }
                    </div>
                </div>
            }
            @if (showEarliestDate()) {
                <div class="timing-select-message">
                    {{ 'woa.message.order-time.earliestDate' | translate:{'date': formattedEarliestLocalDate()} }}
                </div>
            }
            @if (loadingTimes()) {
                <div class="timing-select-message">
                    <div>{{ 'woa.message.order-time.loadingTimes' | translate }}</div>
                    <woa-spinner></woa-spinner>
                </div>
            }
            @if (!timesAvailable() && !loadingTimes()) {
                <div class="timing-select-message">
                    {{ noTimesMessage() | translate:{'storeName': orderingContextModel.currentStore()?.collectiveStoreName} }}
                </div>
            }
            @if (!canOrderLaterTime()) {
                <div class="timing-select-message">
                    {{ 'woa.message.order-time.canOnlyOrderNow' | translate }}
                </div>
            }
        </div>
    </div>
    @if (canOrderLaterTime()) {
        <woa-button woa-page-footer-control id="confirm-time-button"
                    [label]="'woa.button.order-time.confirmTime'"
                    [disabled]="!timesAvailable() || !orderTime() || showDateSelect() || showTimeSelect()"
                    (onActivate)="confirmTime()"></woa-button>
    }
    @if (showAsap()) {
        <woa-button woa-page-footer-control id="confirm-asap-button"
                    [prominence]="ButtonProminence.LOW"
                    [label]="!canOrderLaterTime() ? 'woa.button.common.ok' : 'woa.button.order-time.confirmAsap'"
                    [disabled]="showDateSelect() || showTimeSelect()"
                    (onActivate)="confirmASAP()"></woa-button>
    }
</woa-modal-page-layout>
